<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	  <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="small">
	  	  <div class="backborder3">
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="仓库名称" prop="name">
		                  <el-input v-model="create.name"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="仓库编号" prop="number">
		                  <el-input v-model="create.number"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="负责人">
		                  <el-input v-model="create.contact"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24">
	  	  	  	  <el-col :span="8">
	  	  	  	  	  <el-form-item label="联系电话">
		                  <el-input v-model="create.phone"></el-input>
		              </el-form-item>
	  	  	  	  </el-col>
	  	  	  </el-col>
	  	  	  <el-col :span="24" style="margin-top:10px;text-align:right">
	  	  	  	  <el-form-item>
		              <el-button size="small" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
		          </el-form-item>
	  	  	  </el-col>
	  	  </div>
	  </el-form>
       
  </div>
  </transition>  
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Ware/index",
      transitionshow:true,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        name:'',
        number:'',
        contact:'',
        phone:''
      },
      createLoading:false,
      rules: {
        name: [
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
      
    }
  },
  mounted(){
    this.getactionauth();
    
  },
  methods:{
    
    /** 获取功能操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createLoading=false;                    
			        this.create.name='';
			        this.create.number='';
			        this.create.contact='';
			        this.create.phone='';
                    
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createLoading=false;
              });
          }else {
            return false;
          }
      });
    },
    
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Warehouseadd.vue